module.exports = __webpack_public_path__ + "img/welcome-to-carr-challenge.d1615953.jpg";